import { bool, string, node, arrayOf, oneOfType } from "prop-types";
import { observer } from "mobx-react";
import { PROPOSAL_THUMB_ID } from "@utils";
import { useEditorWebsocket } from "@hooks";
import { useEstimateEditorStore } from "@tools";
import { Sidebar, SortableListV2 } from "@components";
import Grid from "@material-ui/core/Grid";
import { PdfPageThumbnail } from "./index";

export const ThumbnailList = observer(({
  visible,
  noRescale,
  readOnly,
  actions,
  containerId,
  showPageImages
}) => {
  
  const editorStore = useEstimateEditorStore();
  const socket = useEditorWebsocket();

  const { pdfPageThumbnails } = editorStore;

  const onListReorderEnd = (l) => {
    if(!editorStore.pdfPagesLoaded || !editorStore.pdfDocument) return;
    const { usedPages, tablePos } = editorStore.reorderPages(l);
    socket?.updateCoverPages?.(editorStore.pdfDocument.id, usedPages, tablePos);
  }

  return (
    <Sidebar
      noRescale={noRescale}
      noBorder
      actions={actions}
      containerId={containerId}
      visible={visible}
    >
      <Grid
        item container
        className="px-5 py-2 h-full overflow-auto"
        wrap="nowrap"
        ref={(r) => editorStore.setThumbViewRef(r?._container)}
      >
        <SortableListV2
          list={pdfPageThumbnails}
          group="pageThumbnails"
          onListReorder={onListReorderEnd}
          disabled={readOnly}
          direction="column"
          wrap="nowrap"
          lockAxis
        >
          {
            pdfPageThumbnails?.map((page, i) => (
              <PdfPageThumbnail
                key={page.id}
                id={page.id}
                page={page}
                pageIndex={i}
                isRemovable={!readOnly && page.id !== PROPOSAL_THUMB_ID}
                showPageImages={showPageImages}
              />
            ))
          }
        </SortableListV2>
      </Grid>
    </Sidebar>
  );
});

ThumbnailList.propTypes = {
  visible: bool,
  noRescale: bool,
  readOnly: bool,
  showPageImages: bool,
  containerId: string,
  actions: oneOfType([
    arrayOf(node),
    node,
  ]),
};
